import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./components/a1m_adm/Dashboard";
import Landing from "./components/a1m_adm/Landing";
import ControlBoard from "./components/ControlBoard/ControlBoard";

import ResetPassword from "./components/aut3/SSOAuth/reset-password";
import Unauthorized from "./hoc/unauthorized";
import VScanner from "./components/uif7/VScanner";
import ActivityTracker from "./hoc/ActivityTracker";

import Face_auth from "./components/aut3/Face_auth";
import Component1 from "./components/aut3/1";
import Component2 from "./components/aut3/2";

import CryptoTool from "./components/uif7/crypto";
import SecDEL from "./components/uif7/secure_delete";
import Phishing from "./components/uif7/Phishing";
import Backup from "./components/uif7/BackUp";
import IDS_IPS from "./components/uif7/IDS_IPS";
import Hashing from "./components/uif7/Hash";
import  HashMasterPro from "./components/uif7/HashProv2/HashMasterPro";
import CyberNews from "./components/uif7/CyberNews";
import Cybertools from "./components/uif7/cybertools";
import TraceMaster from "./components/uif7/TraceMaster";
import Footprinting from "./components/uif7/Footprinting";
import NetworkDiagnostics from "./components/uif7/NetworkDiagnostics";
import Dashtest from "./components/aut3/dashtext";
import LoginSso from "./components/aut3/LoginSso";
import CallbackSso from "./components/aut3/SSOAuth/CallbackSso";
import SSOPanel from "./components/aut3/SSOPANEL/SSOPanel";
import WAF from "./components/uif7/NgfwControl";
import WAFPolicy from "./components/uif7/WAFPolicyInterface";
import ProtectedRoute from "./hoc/ProtectedRoute";
import CheckAuth from "./hoc/checkAuth";
import DNARelatives from "./components/aut3/DNARelatives";
import Makeup from "./components/GUI/makeup";
import IRSS from "./components/GUI/IRSS_SYS/IRSS_board";
import SecureReporting from "./components/GUI/IRSS_SYS/SecureReporting";
import GeoTracker from "./components/GUI/GovernancePlatform/Issue_Tracker";
import EduHome from "./components/uif7/EduConnect/EduHome";
import EduDoard from "./components/uif7/EduConnect/Dashboard";
import CopyrightPro from "./components/uif7/CopyrightPro";
import  BgdKingdomHome from "./components/GUI/IRSS_SYS/BugandaKingdom";
import CognitoNet from "./components/uif7/CognitoNet";
import { HelmetProvider } from 'react-helmet-async';
import SubnetIQ from "./components/uif7/SubnetIQ/SubnetCalculator";
import  BioPage from "./components/uif7/BiographyPage";
import ThreeLevelAuth from "./components/aut3/ThreeLevelAuth";
import Metaflyse from "./components/uif7/metaflyse";
import LoanDashboard from './components/borrowers/home';
import CybLandingPage from "./components/cybelle/landing";

/// new 18-06-2025
import TimetableSystem from "./components/uif7/TimetableSystem/TimetableBoard"

import PeachCare from "./components/uif7/PechCare/ClinicHomePage";
import PeachBoard from "./components/uif7/PechCare/Home";
import SmartTimetableLanding from "./components/uif7/TimetableSystem/ttHome";


import AbiLoop from "./components/uif7/AbiLoop/Home";
import AbiAuth from "./components/uif7/AbiLoop/Auth";
import AbiBuy from "./components/uif7/AbiLoop/Buy";
import AbiLanding from "./components/uif7/AbiLoop/Landing";
import AbiAdmin from "./components/uif7/AbiLoop/AdminPanel";

import PeaceCraft from "./components/uif7/PeacCraft/Home";
import PeaceLanding from "./components/uif7/PeacCraft/Landing";
import PeaceAuth from "./components/uif7/PeacCraft/Auth";
import PeaceAdmin from "./components/uif7/PeacCraft/AdminPanel";


import HostelSystem from "./components/uif7/HotelSystem/Home";
const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <ActivityTracker>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Dashboard />} />
            <Route path="/Login" element={<LoginSso />} />
            <Route path="/CallbackSso" element={<CallbackSso />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/404" element={<Unauthorized />} />
            <Route path="/cybelle" element={<CybLandingPage />} />

            {/* Loan Management System */}
            <Route path="/loan" element={<LoanDashboard />} />

            <Route path="/1" element={<Component1 />} />
            <Route path="/2" element={<Component2 />} />
            <Route path="/EduHome" element={<EduHome />} />
            <Route path="/EduConnect" element={<Face_auth />} />
            <Route path="/EduDoard" element={<EduDoard />} />
            <Route path="/3lelvelAuth" element={<ThreeLevelAuth />} />

            <Route path="/AbAdmin" element={<AbiAdmin />} />
            <Route path="/ALoop" element={<AbiLoop />} />
            <Route path="/AAuth" element={<AbiAuth />} />
            <Route path="/ALanding" element={<AbiLanding />} />
            <Route path="/ABuy" element={<AbiBuy />} />

            <Route path="/PCraft" element={<PeaceCraft />} />
            <Route path="/PLanding" element={<PeaceLanding />} />
            <Route path="/PAuth" element={<PeaceAuth />} />
            <Route path="/PAdmin" element={<PeaceAdmin />} />

            <Route path="/homeCare" element={<PeachCare />} />
            <Route path="/BoardCare" element={<PeachBoard />} />
            <Route path="/ttmsys" element={<TimetableSystem />} />
            <Route path="/ttsyHome" element={<SmartTimetableLanding />} />

            <Route path="/hostelsys" element={<HostelSystem />} />
            <Route path="/WAFPolicy" element={<WAFPolicy />} />

            <Route path="/:name" element={<BioPage />} />

            {/* Protected Routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/Backup" element={<Backup />} />
              <Route path="/landing" element={<Landing />} />
              <Route path="/crypto" element={<CryptoTool />} />
              <Route path="/TraceMaster" element={<TraceMaster />} />
              <Route path="/hashing" element={<Hashing />} />
              <Route path="/VScanner" element={<VScanner />} />
              <Route path="/Phishing" element={<Phishing />} />
              <Route path="/SubnetIQ" element={<SubnetIQ />} />
              <Route path="/metaflyse" element={<Metaflyse />} />
              <Route path="/WAF" element={<WAF />} />
              <Route path="/CognitoNet" element={<CognitoNet />} />
              <Route path="/SSOPanel" element={<SSOPanel />} />
              <Route path="/ControlBoard" element={<ControlBoard />} />
              <Route path="/SecDEL" element={<SecDEL />} />
            </Route>
          </Routes>
        </ActivityTracker>
      </Router>
    </HelmetProvider>
  );
};

export default App;






{/*
const App = () => {
  return (
    <Router>
      <Routes>

        <Route path="/"  element={<Dashboard />} />
        <Route path="/Login" element={<LoginSso />} />
        <Route path="/landing" element={<Home />} />
        <Route path="/crypto" element={<CryptoTool />} />
        <Route path="/police" element={<Police />} />
        <Route path="/SecDEL" element={<SecDEL />} />
        <Route path="/Idprv" element={<IDS_IPS />} />
        <Route path="/Backup" element={<Backup />} />
        <Route path="/hashing" element={<Hashing />} />
        <Route path="/HashMasterPro" element={<HashMasterPro />} />
        <Route path="/Phishing" element={<Phishing />} />
        <Route path="/CyberNews" element={<CyberNews />} />
        <Route path="/BoardOme" element={<Dashboard />} />
        <Route path="/Cybertools" element={<Cybertools />} />
        <Route path="/TraceMaster" element={<NetAnalyzer />} />
        <Route path="/Footprinting" element={<Footprinting />} />
        <Route path="/NetDiag" element={<NetworkDiagnostics />} />
        <Route path="/Dashtest" element={<Dashtest />} />
        <Route path="/CallbackSso" element={<CallbackSso />} />
        <Route path="/SSOPanel" element={<SSOPanel />} />
        <Route path="/WAF" element={<WAF />} />

        <Route path="/WAFPolicy" element={<WAFPolicy />} />
        <Route path="/DNA" element={<DNARelatives />} />
        <Route path="/1" element={<Component1 />} />  Route for Component1 (1.js)
        <Route path="/2" element={<Component2 />} />  Route for Component2 (2.js)


        <Route path="/IRSS"  element={<IRSS />} />
        <Route path="/Bgdhome"  element={<BgdKingdomHome />} />
        <Route path="/SecReports"  element={<SecureReporting />} />
        <Route path="/CopyrightPro"  element={<CopyrightPro />} />
        <Route path="/EduConnect"  element={<EduConnect />} />
        <Route path="/GT"  element={<GeoTracker />} />
        <Route path="/makeup"  element={<Makeup />} />
        *<Route path="/EduConnect" element={<CheckAuth element={<EduConnect />} />} />
        <Route path="/Landing" element={<ProtectedRoute element={<Landing />} />} />
        <Route path="/BoardOme" element={<ProtectedRoute element={<Dashboard />} />} />


        <Route path="/LoginEduc" element={<Login />} />
      </Routes>
    </Router>
  );
};
export default App;

*/}
